(function () {
  // Only on collection/ntAjax pages
  var isCollection = document.body.classList.contains('template-collection') ||
                     document.querySelector('[data-ntajax-container]');
  if (!isCollection) return;

  // Debounce helper
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  // Grid & card finders (The4/Gecko)
  function getGrids() {
    var grids = [];
    document.querySelectorAll('[data-ntajax-container] .t4s-products').forEach(function (g){ grids.push(g); });
    if (!grids.length) document.querySelectorAll('.t4s-products').forEach(function (g){ grids.push(g); });
    return grids;
  }
  function getCards(grid) {
    // Most The4 builds make cards flex/grid items with `.t4s-product` & `.t4s-col-item`
    var cards = grid.querySelectorAll('.t4s-product');
    return Array.prototype.slice.call(cards);
  }

  // Sold-out detector for your markup
  function isSoldOut(card) {
    // Primary: presence of sold-out badge you showed
    if (card.querySelector('[data-badge-soldout], .t4s-badge-soldout')) return true;

    // Fallbacks: data attrs or badge text
    var da  = card.getAttribute('data-available');
    var dpa = card.getAttribute('data-pr-available');
    if (da === 'false' || dpa === 'false') return true;

    var soldText = (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Sold out';
    var badge = card.querySelector('.t4s-product-badge, .t4s-badge, .badge, [data-product-badge]');
    return !!(badge && badge.textContent.toLowerCase().includes(soldText.toLowerCase()));
  }

  // Apply CSS order (no DOM moves)
  function applyOrder(grid) {
    var cards = getCards(grid);
    if (!cards.length) return;

    // We’ll use order 1 for in-stock, 2 for sold-out
    cards.forEach(function (card) {
      var sold = isSoldOut(card);
      // Only touch when needed to reduce layout work
      var target = sold ? '2' : '1';
      if (card.style.order !== target) {
        card.style.order = target;
        // optional: mark processed to avoid redoing
        card.dataset.soldOrder = target;
      }
    });
  }

  // Run on all grids
  var run = debounce(function () {
    getGrids().forEach(applyOrder);
  }, 10);

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Section events (Shopify/The4)
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
  window.addEventListener('ntajax:updated', run);
  window.addEventListener('ntajax:reloaded', run);

  // Observe for list updates without causing loops (we don’t move nodes, so safe)
  if ('MutationObserver' in window) {
    // Watch the ntAjax containers (filters/pagination)
    document.querySelectorAll('[data-ntajax-container]').forEach(function (container) {
      var mo = new MutationObserver(function (muts) {
        // If products or grid changed, (debounced) re-apply order
        if (muts.some(function (m) { return m.type === 'childList' && m.addedNodes && m.addedNodes.length; })) {
          run();
        }
      });
      mo.observe(container, { childList: true, subtree: true });
    });
  }
})();
